// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"goals_scrollbar__R8AGn"};